const boolToYesNoFn = (value) => {
  return value ? "Yes" : "No";
};

export default {
  boolToYesNo: boolToYesNoFn,
};
